import Swal from "sweetalert2";
export const handleCarDelete = async (
  carId,
  {
    cars,
    setDeletingCarId,
    fetchData,
    rentals,
    coupons,
    contact,
    drivers,
    tours,
    tourBookings,
    employeeService,
    setCarsData,
    setRentalsData,
    setCouponsData,
    setTransfersData,
    setDriversData,
    setToursData,
    setTourBookingsData,
    setEmployeesData,
    setSeasonalPricing,
    setIsLoading,
    setError,
  }
) => {
  try {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this! All related rentals will be kept for record keeping.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#1e3a8a",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      setDeletingCarId(carId);
      await cars.delete(carId);
      await Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "The car has been deleted.",
        confirmButtonColor: "#1e3a8a",
      });    fetchData();
    }
  } catch (error) {
    console.error("Error deleting car:", error);
    await Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to delete car. Please try again.",
      confirmButtonColor: "#1e3a8a",
    });
  } finally {
    setDeletingCarId(null);
  }
};
